/**
 * This file is part of ONP.
 *
 * Copyright (c) Opensoft (http://opensoftdev.com)
 *
 * The unauthorized use of this code outside the boundaries of
 * Opensoft is prohibited.
 *
 * @author Ivetta Kosova <ivetta.kosova@opensoftdev.ru>
 */

define(['jquery', 'assets/js/modules/designFacePreview/guideLines/view/abstractView'], function($, AbstractView) {
    return AbstractView.extend({
        renderBleedZone: function(options) {
            options = options || {};
            var center, radius;
            center = radius = Math.round(this.width / 2);

            this.context.strokeStyle = this.bleedZoneColor;

            if (radius > 0) {
                this._drawCircle(center, radius, options);

                if (options.legend && options.legend.text) {
                    var halfChord = radius * Math.sqrt(1 - Math.pow(20 / radius, 2));
                    this._addLegend(options.legend, center - halfChord, center + 15);
                }
            }
        },

        renderTrimZone: function(options) {
            options = options || {};
            var center = Math.round(this.width / 2);
            var radius = Math.round((this.width - this.getDeltaWidth(this.zones.trimWidth)) / 2);

            this.context.strokeStyle = this.trimZoneColor;

            if (radius > 0) {
                this._drawCircle(center, radius, options);

                if (options.legend && options.legend.text) {
                    this._addLegend(options.legend, 5, Math.round(this.height / 2));
                }
            }
        },

        renderSafeZone: function(options) {
            options = options || {};
            var center = Math.round(this.width / 2);
            var radius = Math.round((this.width - this.getDeltaWidth(this.zones.safeWidth)) / 2);

            this.context.strokeStyle = this.safeZoneColor;

            if (radius > 0) {
                this._drawCircle(center, radius, options);

                if (options.legend && options.legend.text) {
                    var halfChord = radius * Math.sqrt(1 - Math.pow(20 / radius, 2));
                    this._addLegend(options.legend, center - halfChord, center - 15);
                }
            }
        },

        _drawCircle: function(center, radius, options) {
            this.context.beginPath();
            this.context.arc(center, center, radius - 0.5, 0, 2 * Math.PI);
            if (options.background) {
                this.context.fillStyle = options.background;
                this.context.fill();
                if (this.foldingType) {
                    this.textBackground = options.background;
                }
            }
            this.context.stroke();
        }
    });
});
